import { render, staticRenderFns } from "./BigSectionHeading.vue?vue&type=template&id=716424d2&functional=true&"
import script from "./BigSectionHeading.vue?vue&type=script&lang=ts&"
export * from "./BigSectionHeading.vue?vue&type=script&lang=ts&"
import style0 from "./BigSectionHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports